<template>
  <v-app>
    <loading-overlay
      v-show="$root.systemIsBusy()"
      style="position:fixed;height:100%;width:100%;z-index:1000"
      @click="setNotBusy"
    ></loading-overlay>
    <component :is="layout">
      <router-view></router-view>
    </component>
  </v-app>
</template>

<script>
import LoadingOverlay from "./components/LoadingOverlay";
import auth from "./services/authService";

const default_layout = "blank-layout";

export default {
  name: "App",
  beforeMount() {},
  mounted() {
    this.$router.push({ name: "Splash" });
    setTimeout(() => {
      // console.log("AUTOMATICALLY LOGGING OUT FOR THE SAKE OF SPEED!!! DELETE THIS LATER!!!!!");
      // this.$store.dispatch("auth/logout");
      this.preFlightCheck();
    }, 3000);
  },
  data: () => ({
    //
  }),
  methods: {
    preFlightCheck() {
      //HANDLE LOCAL DATABASE
      console.log("STARTING PREFLIGHT!!!");
      this.setNotBusy();
      this.$store
        .dispatch("localdb/setup")
        .then((resp) => {
          //IF WE'RE GOOD THEN KEEP GOING
          if (auth.isAuthenticated()) {
            console.log("AUTHENTICATED");
            this.$root.setBusy("refreshTables", "Refreshing tables. . .");
            this.$store.dispatch("localdb/refreshAllTables").finally(() => {
              this.$root.removeBusy("refreshTables");
              this.$router.push({ name: "CashBalances" });
            });
          } else {
            console.log("NOT AUTHENTICATED");
            this.$router.push({ name: "Login" });
          }
        })
        .catch((err) => {
          console.log("DB CONFIGURATION ERROR!!!!!");
        });
    },
    setNotBusy() {
      this.$root.clearAllBusy();
    },
    isBusy() {
      console.log("BUSY SIZE: " + this.$root.systemIsBusy());
      return !!this.$root.systemIsBusy();
    },
  },
  computed: {
    layout() {
      return this.$route.meta && this.$route.meta.layout ? this.$route.meta.layout : default_layout;
    },
  },
  components: {
    LoadingOverlay,
  },
};
</script>

<style lang="scss">
.negative {
  color: red;
}
</style>
